import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=22611fc1&"
import script from "./SalesOrder.vue?vue&type=script&lang=ts&"
export * from "./SalesOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22611fc1')) {
      api.createRecord('22611fc1', component.options)
    } else {
      api.reload('22611fc1', component.options)
    }
    module.hot.accept("./SalesOrder.vue?vue&type=template&id=22611fc1&", function () {
      api.rerender('22611fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/sales-order/SalesOrder.vue"
export default component.exports